import Store from '../Store';

const MarketStallStatementStore = new Store('markets/statements');


export {MarketStallStatementStore};